<ng-container *ngrxLet="attachedClassifications() as classifications">
	<mat-expansion-panel
		#panel
		[expanded]="!!classifications.length"
		class="au-section-panel"
		hideToggle
	>
		<mat-expansion-panel-header class="classification-header">
			<mat-panel-title>
				<span [class.rotate-right-90]="!panel.expanded" class="arrow"
					><mat-icon
						[ngClass]="classifications.length ? 'accent-icon' : 'ghost-grey-icon'"
						class="icon"
						svgIcon="arrow_down"
					></mat-icon>
				</span>
				<span class="section-name">{{ 'classification' | translate }}</span>
				@if (classifications.length) {
					<span class="circle-container">{{ classifications?.length }}</span>
				}
			</mat-panel-title>

			<mat-panel-description class="description">
				<button
					mat-mini-fab
					(click)="$event.stopPropagation()"
					[matMenuTriggerFor]="entityMenu"
					class="surface-fab"
				>
					<mat-icon svgIcon="add"></mat-icon>
				</button>
			</mat-panel-description>
		</mat-expansion-panel-header>

		<div class="au-table">
			<table [dataSource]="classifications" class="table-container" mat-table>
				<ng-container matColumnDef="type">
					<th *matHeaderCellDef mat-header-cell>
						{{ 'type' | translate }}
					</th>
					<td *matCellDef="let element" mat-cell>
						<span class="type">
							{{ classificationTypeName(element.type) | classificationName | translate }}
						</span>
					</td>
					<td *matFooterCellDef mat-footer-cell>
						<mat-form-field>
							<mat-label>{{ 'type' | translate }}</mat-label>
							<mat-select
								(selectionChange)="userEditableClassificationType.set($event.value)"
								[value]="userEditableClassificationType()"
								[placeholder]="'pick_one' | translate"
							>
								@for (item of classificationsTypes; track item) {
									<mat-option [value]="item.type">
										<span>{{ item.name | translate }}</span>
									</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<ng-container>
						<th *matHeaderCellDef mat-header-cell>
							{{ 'name' | translate }}
						</th>
						<td *matCellDef="let element" mat-cell>
							<div class="classification-name-column">
								<span class="name">{{ element.name }}</span>
								<button
									(click)="removeItemFromSelections(element)"
									[disabled]="!allowedStandardsValue.includes(element.type)"
									class="round-button"
									mat-icon-button
								>
									<mat-icon
										[class.critical-icon]="allowedStandardsValue.includes(element.type)"
										svgIcon="remove-attachment"
									></mat-icon>
								</button>
							</div>
						</td>
						<td *matFooterCellDef mat-footer-cell>
							<mat-form-field>
								<mat-label>{{ 'class_text' | translate }}</mat-label>
								<input
									[formControl]="classificationNameInputControl"
									[matAutocomplete]="auto"
									matInput
									[placeholder]="'start_typing' | translate"
									type="text"
									#filterInput
								/>
								<mat-autocomplete
									#auto
									[displayWith]="displayFn"
									autoActiveFirstOption
									class="nice-scroll visible-scroll colored-scroll-track extra-height"
									(optionSelected)="applySelections(); isFooterRowVisible.set(false)"
								>
									<classification-tree-component
										[data]="filteredOptions()"
										[expandAll]="filterInput.value.length > 1"
									>
										<ng-template let-node>
											<mat-option [value]="node">{{ node.name }}</mat-option>
										</ng-template>
									</classification-tree-component>
								</mat-autocomplete>
							</mat-form-field>
						</td>
					</ng-container>
				</ng-container>

				<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
				<tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
				<tr
					*matFooterRowDef="displayedColumns"
					[hidden]="!isFooterRowVisible()"
					mat-footer-row
				></tr>
			</table>
		</div>
	</mat-expansion-panel>

	<mat-menu
		#entityMenu="matMenu"
		[xPosition]="'after'"
		[yPosition]="'below'"
		class="au-select-actions"
	>
		@for (item of classificationsTypes; track item) {
			<button
				(click)="
					isFooterRowVisible.set(true);
					panel.open();
					userEditableClassificationType.set(item.type)
				"
				class="accent-button"
				mat-menu-item
			>
				<mat-icon class="secondary-text-icon" svgIcon="add" />
				{{ item.name | translate }}
			</button>
		}
	</mat-menu>
</ng-container>
